<!--
 * @Author: wzc
 * @Date: 2021-12-21 10:39:41
 * @LastEditors: wzc
 * @LastEditTime: 2021-12-21 16:48:31
 * tab 切换导航
-->
<template>
  <div
    class="MIXTMT_TAB_NAV"
    :class="tabNavArr.length === 3 ? 'tabThree' : 'tabTwo'"
  >
    <span class="defaultTabRow">
      <span
        class="mixtmt_font_14px"
        @click="tabNavBtn(item)"
        v-for="item in tabNavArr"
        v-text="item.name"
        :key="item.id"
      ></span>
    </span>
    <span class="moveTab" :class="actTabNavObj.className">
      <span class="actTab"></span>
      <span
        class="actTabName mixtmt_font_14px"
        v-text="actTabNavObj.name"
      ></span>
    </span>
    <span class="shadowBg"></span>
  </div>
</template>

<script>
export default {
  name: 'MIXTMT_TAB_NAV',
  props: {
    actTabNavObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
    tabNavBtnHandle: {
      type: Function,
      default: () => {},
    },
    tabNavArr: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     name: "阵容",
        //     act: true,
        //     id: "1",
        //     className: "left"
        //   },
        //   {
        //     name: "球队数据",
        //     act: false,
        //     id: "2",
        //     className: "mid"
        //   },
        //   {
        //     name: "球员数据",
        //     act: false,
        //     id: "3",
        //     className: "right"
        //   }
        // ];
      },
    },
  },
  data() {
    return {}
  },
  created() {
    // this.actTabNavObj = this.tabNavArr[0];
  },
  methods: {
    tabNavBtn(actItem) {
      // this.tabNavArr.forEach(item => {
      //   if (item.id === actItem.id) {
      //     item.act = true;
      //     this.actTabNavObj = item;
      //   } else {
      //     item.act = false;
      //   }
      // });t
      this.tabNavBtnHandle(actItem)
    },
  },
}
</script>

<style lang="scss">
.MIXTMT_TAB_NAV {
  position: relative;
  width: 100%;
  background-color: rgba(239, 240, 242, 1);
  overflow: hidden;
  &.tabThree {
    height: 4.16vw;
    .defaultTabRow {
      padding-top: 0.2778vw;
      height: 4.16vw;
      & > span {
        width: 33.33%;
      }
    }
    .moveTab {
      left: -1.388vw;
      width: 34%;
      &.left {
        left: -1.388vw;
        .actTabName {
          padding-left: 1.388vw;
        }
      }
      &.right {
        left: calc(67% + 1.388vw);
        .actTabName {
          padding-right: 1.388vw;
        }
      }
      &.mid {
        left: 33.33%;
      }
      .actTab {
        display: block;
        background: #fff;
        width: 100%;
        height: 4.16vw;
        position: relative;
        border-radius: 1.388vw 1.388vw 0 0;
        transform: perspective(2.778vw) rotateX(5deg);
        box-shadow: 0 -0.138vw 0.555vw rgba(0, 0, 0, 0.05);
        &::before {
          content: '\20';
          background-image: radial-gradient(
            circle at 30% 70%,
            rgba(255, 255, 255, 0) 1.667vw,
            #fff 0
          );
          position: absolute;
          bottom: -0.555vw;
          right: 100%;
          width: 1.805vw;
          height: 2.778vw;
          transform: perspective(1.388vw) rotate(89deg);
        }
        &::after {
          content: '\20';
          background-image: radial-gradient(
            circle at 70% 30%,
            rgba(255, 255, 255, 0) 1.667vw,
            #fff 0
          );
          position: absolute;
          bottom: 0;
          left: 98%;
          width: 2.778vw;
          height: 1.805vw;
          transform: perspective(1.388vw) rotate(-26deg);
        }
      }
      .actTabName {
        padding-top: 0.2778vw;
      }
    }
  }
  &.tabTwo {
    height: 5vw;
    .defaultTabRow {
      padding-top: 0.555vw;
      height: 5vw;
      & > span {
        width: 50%;
      }
    }
    .moveTab {
      left: -2.778vw;
      width: 50%;
      &.left {
        left: -2.778vw;
        .actTabName {
          padding-left: 2.778vw;
        }
      }
      &.right {
        left: calc(50% + 2.778vw);
        .actTabName {
          padding-right: 2.778vw;
        }
      }
      .actTab {
        display: block;
        background: #fff;
        width: 100%;
        height: 5vw;
        position: relative;
        border-radius: 1.667vw 1.667vw 0 0;
        transform: perspective(2.778vw) rotateX(5deg);
        box-shadow: 0 -0.138vw 0.555vw rgba(0, 0, 0, 0.05);
        &::before {
          content: '\20';
          background-image: radial-gradient(
            circle at 30% 70%,
            rgba(255, 255, 255, 0) 1.94vw,
            #fff 0
          );
          position: absolute;
          bottom: -0.555vw;
          right: 100%;
          width: 2.083vw;
          height: 3.47vw;
          transform: perspective(1.388vw) rotate(89deg);
        }
        &::after {
          content: '\20';
          background-image: radial-gradient(
            circle at 70% 30%,
            rgba(255, 255, 255, 0) 1.94vw,
            #fff 0
          );
          position: absolute;
          bottom: 0;
          left: 98%;
          width: 3.47vw;
          height: 2.083vw;
          transform: perspective(1.388vw) rotate(-26deg);
        }
      }
      .actTabName {
        padding-top: 0.555vw;
      }
    }
  }
  .defaultTabRow {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    & > span {
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
    }
  }
  .moveTab {
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: 5;
    transition: left 0.3s ease-in-out;
    .actTabName {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      z-index: 20;
      width: 100%;
      transform: translate(-50%, -50%);
      color: rgba(0, 0, 0, 0.85);
      text-align: center;
      font-weight: bold;
    }
  }
  .shadowBg {
    display: block;
    width: 100%;
    height: 0.694vw;
    background-color: #fff;
    box-shadow: 0 -0.138vw 0.555vw rgba(0, 0, 0, 0.05);
  }
  .topBg {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    display: block;
    width: 100%;
    height: 1.388vw;
    background-color: #fff;
  }
}
</style>
